// extracted by mini-css-extract-plugin
export default {"loading-indicator":"loading-indicator-UZZBx5_","white":"white-ZNtpVob","icon":"icon-QcPjCBI","grey":"grey-ZgPx6k2","icon-wrapper":"icon-wrapper-_eH1ag5","spin":"spin-qP2weBb"};